import { render, staticRenderFns } from "./breed_formula_page.vue?vue&type=template&id=51deaafe&scoped=true"
import script from "./breed_formula_page.vue?vue&type=script&lang=js"
export * from "./breed_formula_page.vue?vue&type=script&lang=js"
import style0 from "./breed_formula_page.vue?vue&type=style&index=0&id=51deaafe&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51deaafe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51deaafe')) {
      api.createRecord('51deaafe', component.options)
    } else {
      api.reload('51deaafe', component.options)
    }
    module.hot.accept("./breed_formula_page.vue?vue&type=template&id=51deaafe&scoped=true", function () {
      api.rerender('51deaafe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/knowledge/breed_formula_page.vue"
export default component.exports